namespace RS
{
    const shouldExposeCommand = true;
    const commandName = "rsdump";

    export interface IDump
    {
        /** Whether or not dumping is enabled. If false, new messages will not be stored. */
        enabled: boolean;

        /** Published before the dump is saved. */
        readonly onPreSave: IEvent<IDump>;

        /** Gets a named sub-dump. */
        getSubDump(name: string): ISubDump;

        /** Saves the dump. Also clears the dump. */
        save(): void | Promise<void>;

        /** Clears the dump. */
        clear(): void;
    }

    export interface ISubDump extends IDisposable
    {
        /** Adds an object to this sub dump. */
        add(object: object, whitelistFn?: (this: object, key: string, value: object) => boolean): void;
        /** Adds something to this sub dump. */
        add(data: any): void;

        /** Clears this sub dump. */
        clear(): void;
    }

    export const IDump = Strategy.declare<IDump>(Strategy.Type.Singleton, false, true);

    if (shouldExposeCommand)
    {
        window[commandName] = async function ()
        {
            const dump = IDump.get();
            await dump.save();
        };
    }
}